import React, { useState } from 'react'
import { useTranslation } from 'next-i18next'
import { FaUser } from 'react-icons/fa'
import { useDispatch, useSelector } from 'react-redux'
import Link from 'next/link'
import { DragDropModal } from 'components/Modals'
import { toggleAuthModal } from 'store/actions/header.action'
import { MdOutlineDashboard } from 'react-icons/md'
import { useRouter } from 'next/router'

const MobileFooter = () => {
  const user = useSelector((state) => state.auth.user)
  const { t } = useTranslation('common')
  const router = useRouter()
  const dispatch = useDispatch()

  const [showContainer, setShowContainer] = useState(false)
  const [dragDropVisible, setDragDropVisible] = useState(false)

  const openModal = (modalType) => {
    router.push(
      {
        pathname: router.pathname,
        query: { ...router.query, modalType }, // Add a route query for the modal
      },
      undefined,
      { shallow: true } // Prevent full page reload
    )
  }
  return (
    <div className="mobile-footer md:hidden">
      {dragDropVisible && (
        <DragDropModal
          onClose={() => setDragDropVisible(false)}
          afterUploadCompleted={() => {
            setShowContainer(false)
          }}
        />
      )}
      <div className="fixed bg-black bottom-0 left-0 w-full z-[999999]">
        <div className="flex w-full justify-around">
          <div className="p-4 filter invert">
            <Link href={'/'} target={'_self'} rel="noreferrer">
              <img src={`/assets/common/home-mobile.svg`} alt="home" className="w-6 h-6" />
            </Link>
          </div>
          <div className="p-4 filter invert">
            <Link href={'/explore-models'} target={'_self'} rel="noreferrer">
              <img src={`/assets/common/search-mobile.svg`} alt="search" className="w-6 h-6" />
            </Link>
          </div>
          <div
            className="px-4 py-2"
            onClick={() => (user ? setShowContainer(!showContainer) : dispatch(toggleAuthModal('sign_in')))}
          >
            <div className="bg-white rounded-full w-11 h-11 flex justify-center items-center">
              <img src={`/assets/common/add-mobile.svg`} alt="add" className="w-4 h-4" />
            </div>
            {showContainer && (
              <>
                <div className="bg-white flex flex-col items-start justify-start border-1 border-solid border-black border-opacity-10 w-[280px] z-[999] absolute left-[10%] right-[10%] rounded-lg !bottom-[50px] !p-[10px] !gap-[10px]">
                  <div className="flex gap-3 w-full" onClick={() => setDragDropVisible(true)}>
                    <img src="/assets/dashboard/media-icon.svg" alt="media" className="w-5" />
                    <div>
                      <p className="text-sm">Upload Media</p>
                      <p className="text-xs text-left opacity-45">{t('common.upload-media-comment')}</p>
                    </div>
                  </div>
                  <div className="flex gap-3 w-full" onClick={() => openModal('editor')}>
                    <img src="/assets/dashboard/models-icon.svg" alt="media" className="w-5" />
                    <div>
                      <p className="text-sm">Create Media</p>
                      <p className="text-xs text-left opacity-45">create amazing media using AI Models</p>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
          <div className="p-4 filter invert">
            <Link href={'/chat'} target={'_self'} rel="noreferrer">
              <img src={`/assets/common/chat-mobile.svg`} alt="chat" className="w-6 h-6" />
            </Link>
          </div>
          <div className="p-4 filter invert">
            <div className="w-[24px] h-[24px]  font-bold flex items-center justify-center">
              {user ? (
                user?.avatar_url ? (
                  <Link href={'/dashboard'} target={'_self'} rel="noreferrer">
                    <MdOutlineDashboard className="rounded-full object-cover object-top h-6 w-6" />
                  </Link>
                ) : (
                  <Link href={'/dashboard'} target={'_self'} rel="noreferrer">
                    <FaUser size={'24px'} className="text-[24px] rounded-full" />
                  </Link>
                )
              ) : (
                <FaUser
                  size={'24px'}
                  className="text-[20px] rounded-full "
                  onClick={() => dispatch(toggleAuthModal('sign_in'))}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MobileFooter
